import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Resource } from './Resource.mjs';
import { BaseTexture } from '../BaseTexture.mjs';
import { autoDetectResource } from './autoDetectResource.mjs';
var AbstractMultiResource = /*#__PURE__*/function (_Resource) {
  _inherits(AbstractMultiResource, _Resource);
  var _super = _createSuper(AbstractMultiResource);
  function AbstractMultiResource(length, options) {
    var _this;
    _classCallCheck(this, AbstractMultiResource);
    var _ref = options || {},
      width = _ref.width,
      height = _ref.height;
    _this = _super.call(this, width, height);
    _this.items = [];
    _this.itemDirtyIds = [];
    for (var i = 0; i < length; i++) {
      var partTexture = new BaseTexture();
      _this.items.push(partTexture);
      _this.itemDirtyIds.push(-2);
    }
    _this.length = length;
    _this._load = null;
    _this.baseTexture = null;
    return _this;
  }
  _createClass(AbstractMultiResource, [{
    key: "initFromArray",
    value: function initFromArray(resources, options) {
      for (var i = 0; i < this.length; i++) {
        if (!resources[i]) {
          continue;
        }
        if (resources[i].castToBaseTexture) {
          this.addBaseTextureAt(resources[i].castToBaseTexture(), i);
        } else if (resources[i] instanceof Resource) {
          this.addResourceAt(resources[i], i);
        } else {
          this.addResourceAt(autoDetectResource(resources[i], options), i);
        }
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      for (var i = 0, len = this.length; i < len; i++) {
        this.items[i].destroy();
      }
      this.items = null;
      this.itemDirtyIds = null;
      this._load = null;
    }
  }, {
    key: "addResourceAt",
    value: function addResourceAt(resource, index) {
      if (!this.items[index]) {
        throw new Error("Index ".concat(index, " is out of bounds"));
      }
      if (resource.valid && !this.valid) {
        this.resize(resource.width, resource.height);
      }
      this.items[index].setResource(resource);
      return this;
    }
  }, {
    key: "bind",
    value: function bind(baseTexture) {
      if (this.baseTexture !== null) {
        throw new Error("Only one base texture per TextureArray is allowed");
      }
      _get(_getPrototypeOf(AbstractMultiResource.prototype), "bind", this).call(this, baseTexture);
      for (var i = 0; i < this.length; i++) {
        this.items[i].parentTextureArray = baseTexture;
        this.items[i].on("update", baseTexture.update, baseTexture);
      }
    }
  }, {
    key: "unbind",
    value: function unbind(baseTexture) {
      _get(_getPrototypeOf(AbstractMultiResource.prototype), "unbind", this).call(this, baseTexture);
      for (var i = 0; i < this.length; i++) {
        this.items[i].parentTextureArray = null;
        this.items[i].off("update", baseTexture.update, baseTexture);
      }
    }
  }, {
    key: "load",
    value: function load() {
      var _this2 = this;
      if (this._load) {
        return this._load;
      }
      var resources = this.items.map(function (item) {
        return item.resource;
      }).filter(function (item) {
        return item;
      });
      var promises = resources.map(function (item) {
        return item.load();
      });
      this._load = Promise.all(promises).then(function () {
        var _this2$items$ = _this2.items[0],
          realWidth = _this2$items$.realWidth,
          realHeight = _this2$items$.realHeight;
        _this2.resize(realWidth, realHeight);
        return Promise.resolve(_this2);
      });
      return this._load;
    }
  }]);
  return AbstractMultiResource;
}(Resource);
export { AbstractMultiResource };